import styled, { css } from 'styled-components';
import { colors } from '@prisjakt/ui-base';
import { priceLabelStylingType, priceLabel } from './types';

type PriceLabelProps = {
  bold?: boolean;
  styling: priceLabelStylingType;
  campaignStyling?: { background: string; text: string; name: string } | null;
};

export const PriceLabel = styled.span.attrs({ 'data-test': 'PriceLabel' })<
  PriceLabelProps
>(
  props => css`
    font-size: inherit;
    font-weight: ${props.bold ? 'bold' : 'inherit'};

    ${props.styling === priceLabel.PRIMARY &&
      css`
        color: ${colors.darkBlue1};
      `}

    ${props.styling === priceLabel.SECONDARY &&
      css`
        color: ${colors.darkGray4};
      `}

    ${props.styling === priceLabel.LIGHTEN &&
      css`
        color: ${colors.darkGray2};
      `}

    ${props.styling === priceLabel.CAMPAIGN &&
      css`
        color: ${colors.red1};
      `}
  `
);
